module.exports = __webpack_public_path__ + "img/12.b4d886af.jpg";